import { useEffect, useState } from 'react';
import styles from './PremanentWorkTime.module.css';
import { SlOptionsVertical } from "react-icons/sl";
import Popup from 'components/Popup/popup';
import { WorkTimeSlot } from 'modules/calendar-worktime-holiday';
import { fetchWorkSlots } from 'services/workTime/calendar-service';
import ErrorFailed from 'components/errorFailed/errorFailed';
import { addWorkBlock } from 'services/workTime/add-work-block';
import { deleteWorkBlock } from 'services/workTime/delete-work-block';
import { openWorkDay } from 'services/workTime/open-work-day';
import { formatDate } from 'utils/bookingPopup';
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { fetchBookings } from 'utils/workTime';
import SuccessPopup from 'components/successPopup/successPopup';

interface Day {
    name: string;
    isOpen: boolean;
    times: WorkTimeSlot[];
}

export default function PremanentWorkTime() {
    const [startTime, setStartTime] = useState<string>('');
    const [endTime, setEndTime] = useState<string>('');
    const [placeNo, setPlaceNo] = useState<string>('9');
    const [emergencyPlacesNo, setEmergencyPlacesNo] = useState<string>('5');
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
    const [days, setDays] = useState<Day[]>([
        { name: 'Montag', isOpen: false, times: [] },
        { name: 'Dienstag', isOpen: false, times: [] },
        { name: 'Mittwoch', isOpen: false, times: [] },
        { name: 'Donnerstag', isOpen: false, times: [] },
        { name: 'Freitag', isOpen: false, times: [] },
    ]);
    const [selectedDayIndex, setSelectedDayIndex] = useState<number | null>(null);
    const [showOptions, setShowOptions] = useState<number | null>(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [showAddPopup, setShowAddPopup] = useState(false);
    const [selectedTimeSlots, setSelectedTimeSlots] = useState<number[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [bookingsForDeletion, setBookingsForDeletion] = useState<{ id: number; age: number; recurrence?: string, date: Date, isprimey: boolean, name: string, block: string }[]>([]);
    const [showConfirmClosePopup, setShowConfirmClosePopup] = useState(false);
    const [showConfirmDeletionPopup, setShowConfirmDeletionPopup] = useState(false);
    const [workTimeSlots, setWorkTimeSlots] = useState<WorkTimeSlot[]>([]);
    const [selectedIdToDelete, setSelectedIdToDelete] = useState<number[]>([]);


    const fetchData = async () => {
        try {
            const workData = await fetchWorkSlots();
            setWorkTimeSlots(workData);
            updateDaysWithSlots(workData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const updateDaysWithSlots = (slots: WorkTimeSlot[]) => {
        const updatedDays = days.map(day => {
            const daySlots = slots.filter(slot => slot.day_of_week === day.name);
            const sortedSlots = daySlots.sort((a, b) => {
                if (a.start_time === b.start_time) {
                    return a.end_time.localeCompare(b.end_time);
                }
                return a.start_time.localeCompare(b.start_time);
            });
            return {
                ...day,
                isOpen: daySlots.length > 0,
                times: sortedSlots
            };
        });
        setDays(updatedDays);
    };

    useEffect(() => {
        fetchData();

    }, []);

    const toggleDayOpen = async (dayIndex: number) => {
        const day = days[dayIndex];
        try {
            if (day.isOpen) {
                const blocksForDay = workTimeSlots.filter((slot) => slot.day_of_week === day.name);
                const blocksid = blocksForDay
                    .map((block) => block.id)
                    .filter((id): id is number => id !== undefined);

                setSelectedIdToDelete(blocksid);
                const today = new Date();
                const bookingsForDeletion = await fetchBookings(blocksid, today);

                setBookingsForDeletion(bookingsForDeletion);
                setShowConfirmClosePopup(true);
                // await closeWorkDay(day.name);
            } else {
                await openWorkDay(day.name);
            }
            await fetchData();

        } catch (error) {
            console.error(`Error ${day.isOpen ? 'closing' : 'opening'} ${day.name}:`, error);
        }
    };

    const handleOptionClick = (dayIndex: number) => {
        setShowOptions(dayIndex === showOptions ? null : dayIndex);
        setSelectedDayIndex(dayIndex);
    };

    const handleDeleteClick = () => {
        setShowDeletePopup(true);
        setShowOptions(null);
    };

    const handleAddClick = () => {
        setShowAddPopup(true);
        setShowOptions(null);
    };

    const closePopups = async () => {
        await fetchData();
        setShowDeletePopup(false);
        setShowAddPopup(false);
        setSelectedTimeSlots([]);
        setEndTime('');
        setStartTime('');
        setPlaceNo('9');
        setEmergencyPlacesNo('5');
        setShowConfirmDeletionPopup(false);
        setShowConfirmClosePopup(false);
        setBookingsForDeletion([]);
        setError(null);
    };


    const handleAddSubmit = async () => {
        if (selectedDayIndex !== null && startTime && endTime) {
            const newWorkSlot: WorkTimeSlot = {
                day_of_week: days[selectedDayIndex].name,
                start_time: startTime,
                end_time: endTime,
                number_of_places: Number(placeNo),
                emergency_places: Number(emergencyPlacesNo),
            };
            const newStart = new Date(`1970-01-01T${newWorkSlot.start_time}:00`);
            const newEnd = new Date(`1970-01-01T${newWorkSlot.end_time}:00`);

            if (newStart >= newEnd) {
                setError("Die Startzeit muss vor der Endzeit liegen.");
                return;
            }
            const currentSlots = days[selectedDayIndex].times;
            const isOverlapping = currentSlots.some(slot => {
                const slotStart = new Date(`1970-01-01T${slot.start_time}`);
                const slotEnd = new Date(`1970-01-01T${slot.end_time}`);
                return (
                    (newStart >= slotStart && newStart < slotEnd) ||
                    (newEnd > slotStart && newEnd <= slotEnd) ||
                    (newStart <= slotStart && newEnd >= slotEnd)
                );
            });

            if (isOverlapping) {
                setError("Die neue Arbeitszeit überschneidet sich mit einer bestehenden.");
                return;
            }
            else if (Number(placeNo) <= 0) {
                setError("Platzanzahl kann nicht kleiner oder gleich null sein.");
                return;
            }
            else if (Number(emergencyPlacesNo) <= 0) {
                setError("NotfallPlatzanzahl kann nicht kleiner oder gleich null sein.");
                return;
            }
            try {
                await addWorkBlock(newWorkSlot);
                await fetchData();
                closePopups();
                setError(null);
            } catch (error) {
                console.error("Error adding work time slot:", error);
                setError("Fehler beim Hinzufügen der Arbeitszeit.");
            }
        } else {
            setError("Bitte füllen Sie alle Felder aus.");
        }
    };

    const handleDeleteSubmit = async () => {
        if (selectedDayIndex !== null) {
            const today = new Date();

            const idsToDelete: number[] = selectedTimeSlots
                .map((timeIndex) => days[selectedDayIndex].times[timeIndex]?.id)
                .filter((id): id is number => id !== undefined);

            const bookingsForDeletion = await fetchBookings(idsToDelete, today);
            setBookingsForDeletion(bookingsForDeletion);
            setShowConfirmDeletionPopup(true);

        }
    };

    const confirmCloseDay = async () => {
        if (selectedIdToDelete !== null) {
            
            try {
                deleteWorkBlock(selectedIdToDelete, bookingsForDeletion);
                await fetchData();
            } catch (error) {
                console.error("Error deleting time slots:", error);
            } finally {
                await fetchData();

                setIsSuccessPopupOpen(true);

            }
        }
    };

    const confirmDeleteBlocks = async () => {
        if (selectedDayIndex !== null) {
            const idsToDelete = selectedTimeSlots.map(
                (timeIndex) => days[selectedDayIndex].times[timeIndex].id
            );

            try {
                deleteWorkBlock(idsToDelete, bookingsForDeletion);
                await fetchData();

            } catch (error) {
                console.error("Error deleting time slots:", error);
            } finally {
                await fetchData();
                setIsSuccessPopupOpen(true)
            }
        }
    };

    const toggleTimeSlotSelection = (timeIndex: number) => {
        setSelectedTimeSlots(prev =>
            prev.includes(timeIndex)
                ? prev.filter(index => index !== timeIndex)
                : [...prev, timeIndex]
        );
    };

    return (
        <div className={styles.container}>
            {days.map((day, index) => (
                <div key={index} className={styles.dayContainer}>
                    <div className={styles.dayName}>{day.name}</div>
                    <div className={styles.toggle}>
                        <label className={styles.switch}>
                            <input
                                type="checkbox"
                                checked={day.isOpen}
                                onChange={() => toggleDayOpen(index)}
                            />
                            <span className={styles.slider}></span>
                        </label>
                        <span className={styles.status}>{day.isOpen ? 'geöffnet' : 'geschlossen'}</span>
                    </div>
                    <div className={styles.timeSlots}>
                        {day.isOpen && day.times.map((time, timeIndex) => (
                            <div key={timeIndex} className={styles.timeSlot}>
                                <span>{time.start_time.substring(0, 5)}</span> - <span>{time.end_time.substring(0, 5)} </span> - <span>{time.number_of_places} Plätze </span> - <span>{time.emergency_places} Notfallplätze </span>
                            </div>

                        ))}
                    </div>
                    <div className={styles.options}>
                        <button
                            className={styles.editBtn}
                            onClick={() => handleOptionClick(index)}
                        >
                            <SlOptionsVertical />
                        </button>
                        {showOptions === index && (
                            <div className={styles.optionMenu}>
                                <button onClick={handleDeleteClick}>Block löschen</button>
                                <button onClick={handleAddClick}>Block hinzufügen</button>
                            </div>
                        )}
                    </div>
                </div>
            ))}

            {showDeletePopup && selectedDayIndex !== null && (
                <Popup
                    title={"Block löschen"}
                    submitLabel={"löschen"}
                    closeLabel={"Abbrechen"}
                    isWithButton={true}
                    isOpen={true}
                    onClose={closePopups}
                    onSubmit={handleDeleteSubmit}
                >
                    <p>Wählen Sie die Zeitblöcke, die Sie löschen möchten:</p>
                    <div className={styles.timeSlotOption}>
                        {days[selectedDayIndex].times.map((time, timeIndex) => (
                            <div key={timeIndex} className={styles.timeSlotOptionLine}>
                                <input
                                    type="checkbox"
                                    checked={selectedTimeSlots.includes(timeIndex)}
                                    onChange={() => toggleTimeSlotSelection(timeIndex)}
                                />
                                <span>{time.start_time.substring(0, 5)} - {time.end_time.substring(0, 5)}</span>
                            </div>
                        ))}
                    </div>
                </Popup>
            )}

            {showConfirmDeletionPopup && (
                <Popup
                    title={"Bestätigung der Löschung"}
                    submitLabel={"Löschen bestätigen"}
                    closeLabel={"Abbrechen"}
                    isWithButton={true}
                    isOpen={true}
                    onClose={() => setShowConfirmDeletionPopup(false)}
                    onSubmit={confirmDeleteBlocks}
                >
                    {bookingsForDeletion.length != 0 ? (
                        <><ErrorFailed error={'Dieser Vorgang ist unwiderruflich.'} /><div className={commonStyles.formGroup}>
                            <div className={styles.rejectOptionsContainer}>
                                <p> Sind Sie sicher, dass Sie die Blöcke und deren Buchungen ablehnen möchten?</p>
                                <p>Folgende Buchungen sind mit den ausgewählten Blöcken verknüpft:</p>
                                {bookingsForDeletion.map((booking, index) => (
                                    <div className={styles.rejectOptionsRow} key={`${booking.id}-${booking.date}`}>
                                        <div className={styles.rejectOptionsRowLabels}>
                                            <label>
                                                {`Kind: ${booking.name}`}
                                            </label>
                                            <label>
                                                {`${booking.age} J`}
                                            </label>
                                            <label>
                                                {`${formatDate(booking.date)}`}
                                            </label>
                                            <label>
                                                {`${booking.block}`}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div></>
                    ) : (
                        <p>Es gibt keine Buchungen, die mit diesen Blöcken verknüpft sind.</p>
                    )}
                </Popup>
            )}
            {showConfirmClosePopup && (
                <Popup
                    title={"Bestätigung der Löschung"}
                    submitLabel={"Löschen bestätigen"}
                    closeLabel={"Abbrechen"}
                    isWithButton={true}
                    isOpen={true}
                    onClose={() => setShowConfirmClosePopup(false)}
                    onSubmit={confirmCloseDay}
                >
                    {bookingsForDeletion.length != 0 ? (
                        <><ErrorFailed error={'Dieser Vorgang ist unwiderruflich.'} /><div className={commonStyles.formGroup}>
                            <div className={styles.rejectOptionsContainer}>
                                <p> Sind Sie sicher, dass Sie die Blöcke und deren Buchungen ablehnen möchten?</p>
                                <p>Folgende Buchungen sind mit den ausgewählten Blöcken verknüpft:</p>
                                {bookingsForDeletion.map((booking, index) => (
                                    <div className={styles.rejectOptionsRow} key={`${booking.id}-${booking.date}`}>
                                        <div className={styles.rejectOptionsRowLabels}>
                                            <label>
                                                {`Kind: ${booking.name}`}
                                            </label>
                                            <label>
                                                {`${booking.age} J`}
                                            </label>
                                            <label>
                                                {`${formatDate(booking.date)}`}
                                            </label>
                                            <label>
                                                {`${booking.block}`}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div></>
                    ) : (
                        <p>Es gibt keine Buchungen, die mit diesen Blöcken verknüpft sind.</p>
                    )}

                </Popup>
            )}
            {showAddPopup && (
                <Popup title={"Block hinzufügen"} submitLabel={"Hinzufügen"} closeLabel={"Abbrechen"} isWithButton={true} isOpen={true} onClose={closePopups} onSubmit={handleAddSubmit}>
                    {error && <ErrorFailed error={error} />}
                    <p>Bitte geben Sie die Start- , Endzeit und Platzanzahl des neuen Blocks ein:</p>
                    <div className={styles.blockInput}>
                        <input
                            type="time"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                        <p>-</p>
                        <input
                            type="time"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                        <p>-</p>
                        <input
                            type="number"
                            value={placeNo}
                            onChange={(e) => setPlaceNo(e.target.value)}
                        />
                        <p>Plätze</p>  <p>-</p>
                        <input
                            type="number"
                            value={emergencyPlacesNo}
                            onChange={(e) => setEmergencyPlacesNo(e.target.value)}
                        />
                        <p>Notfallplätze</p>
                    </div>
                </Popup>
            )}
            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                closePopups();
                setIsSuccessPopupOpen(false);
            }} />
        </div>
    );
}
